import * as React from "react";
import styled from "styled-components";

import { Container } from "@ui/Atoms/Grid";
import theme from "@ui/themes/default";
import { Heading, Segment } from "@ui/Atoms";
import { Steps, Icon } from "@ui/Molecules/Steps";

export interface HowItWorksData {
  // prismic
  how_it_works_title?: { text: string };
  how_it_works_step_one_description?: { text: string };
  how_it_works_step_one_icon?: string;
  how_it_works_step_two_description?: { text: string };
  how_it_works_step_two_icon?: string;
  how_it_works_step_three_description?: { text: string };
  how_it_works_step_three_icon?: string;
}

interface Props {
  data?: HowItWorksData;
  iconsSize?: number;
}

const HowItWorks = (props: Props): React.ReactElement => (
  <Background>
    <Container>
      <Segment>
        <Title type="h2" styleAs="h4">
          {props.data?.how_it_works_title?.text || ""}
        </Title>
        <Steps
          steps={[
            {
              icon: props.data?.how_it_works_step_one_icon as Icon,
              markdownContent:
                props.data?.how_it_works_step_one_description?.text || "",
            },
            {
              icon: props.data?.how_it_works_step_two_icon as Icon,
              markdownContent:
                props.data?.how_it_works_step_two_description?.text || "",
            },
            {
              icon: props.data?.how_it_works_step_three_icon as Icon,
              markdownContent:
                props.data?.how_it_works_step_three_description?.text || "",
            },
          ]}
        />
      </Segment>
    </Container>
  </Background>
);

export { HowItWorks };

const Background = styled.div`
  background: ${theme.palette.grey50};
`;

const Title = styled(Heading)`
  margin-bottom: ${theme.margins.base_x6};
  font-weight: ${theme.fonts.weights.bold};
`;
